import styled from 'styled-components'

export const PaginacaoBox = styled.div`

`

PaginacaoBox.Paginas = styled.div`
    text-align: center;
    padding-bottom: 30px;
    padding-top: 10px;
`

PaginacaoBox.Exportacao = styled.div`
    display: inline-flex;
    position: relative;
    float: right;
    padding-top: 10px;
`

PaginacaoBox.ExportacaoAcao = styled.div`
    padding: 0 5px 0 5px
`

PaginacaoBox.PrintPage = styled.div`
    padding: 0 5px 0 5px;
    
`